<section [style.width]="width" class="page testers-list">
    <h1 class="page__title">
        {{headTitle}}
    </h1>

    <h2 *ngIf="description" class="page__description">
        {{description}}
    </h2>

    <ng-container [ngTemplateOutlet]="tableActionHead"></ng-container>
    <div class="datagrid">
        <div [nbSpinner]="spinner" class="grid">
            <ng-content></ng-content>
        </div>
        <app-pagination (setPage)="setPage.emit($event)" [lastPage]="lastPage"></app-pagination>
    </div>
</section>

